import * as React from 'react';

import {Button} from 'shells/button/button';

import type {
    SmsBroadcastFragment_edition_from as Channel,
    SmsBroadcastFragment_edition as Edition,
} from 'nutshell-graphql-types';

import type {SelectedRecipients} from '../../../editions/prepare-to-send-page/new-recipients-selection-view';

import {MIN_CHARACTERS, MAX_CHARACTERS} from '../../consts';

export const getHasCharacterCountError = (characterCount: number): boolean => {
    return characterCount > MAX_CHARACTERS || characterCount < MIN_CHARACTERS;
};

export const getIssueCount = (
    characterCount: number,
    hasShortLink: boolean,
    from?: Channel | null
): number => {
    let count = 0;
    if (getHasCharacterCountError(characterCount)) {
        count++;
    }

    if (hasShortLink) {
        count++;
    }

    if (!from) {
        count++;
    }

    return count;
};

export const getCharacterCountSubtitle = (characterCount: number): string => {
    let text = `Between ${MIN_CHARACTERS} and ${MAX_CHARACTERS} characters`;

    if (characterCount > MAX_CHARACTERS) {
        const extraCharacters = characterCount - MAX_CHARACTERS;

        text = `${extraCharacters} ${
            extraCharacters === 1 ? 'character' : 'characters'
        } over maximum of ${MAX_CHARACTERS} limit`;
    }
    if (characterCount < MIN_CHARACTERS) {
        const missingCharacters = MIN_CHARACTERS - characterCount;

        text = `${missingCharacters} ${
            missingCharacters === 1 ? 'character' : 'characters'
        } under minimum of ${MIN_CHARACTERS}`;
    }

    return text;
};

export const getActionElement = (
    hasError: boolean,
    onClick: () => void
): React.ReactElement<any> | null | undefined => {
    if (hasError) {
        return (
            <Button variant='text-primary' size='big' onClick={onClick}>
                Edit your message
            </Button>
        );
    }
};

export function getAudienceError(edition: Edition, selectedRecipients?: SelectedRecipients | null) {
    let audienceError = null;
    if (
        edition.smsCampaignsCreditLimit &&
        selectedRecipients &&
        selectedRecipients.recipientSelection
    ) {
        if (
            edition.smsCampaignsCreditsUsed + selectedRecipients.recipientSelection.recipientCount >
            edition.smsCampaignsCreditLimit
        ) {
            const creditsRemaining =
                edition.smsCampaignsCreditLimit - edition.smsCampaignsCreditsUsed;
            audienceError = `You have ${creditsRemaining} credits remaining and the selected list will put you over your SMS campaign sending limit for this month. Please upgrade your plan or use another list to continue.`;
        }
    }

    return audienceError;
}
